// Taken from ~/libs/components/src/lib/autocomplete-input/selected-values.tsx

import { WppPill } from '@wppopen/components-library-react'
import clsx from 'clsx'
import type { AutocompleteDefaultOption } from '@wppopen/components-library'
import styles from './SelectedValues.module.scss'

interface SelectedValuesComponent {
  /** Options holds 2 params: country name and its corresponding unique id*/
  values: AutocompleteDefaultOption[]
  /** optional class name for the container */
  className?: string
  /** Event handler will take an id and will remove the selected value from the selected list  */
  handleRemove: (e: number | string) => void
}

/**
 * A component that show in pills style the values/countries selected.
 *
 * @returns Selected values component to generate an selected values list.
 */
const SelectedValues = ({ values, className, handleRemove }: SelectedValuesComponent) => {
  return (
    <div className={clsx(className)}>
      {values.map(({ id, label }) => (
        <WppPill
          label={label}
          removable
          value={id}
          onWppClose={() => handleRemove(id)}
          type="display"
          key={id}
          className={styles.pillSpacer}
        >
          {label}
        </WppPill>
      ))}
    </div>
  )
}
export default SelectedValues
